import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { completeFinanceSession } from "../utils/apiClient";

const startedKeys = new Set();

function FinanceCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const bankError = searchParams.get("error");
    if (bankError) {
      setError(searchParams.get("error_description") || bankError);
      return;
    }
    if (!code || !state) {
      setError("Mangler godkendelseskode fra banken.");
      return;
    }
    const key = `${code}:${state}`;
    if (startedKeys.has(key)) {
      return;
    }
    startedKeys.add(key);
    (async () => {
      try {
        await completeFinanceSession({ code, state });
        navigate("/profile?tab=bank", { replace: true });
      } catch (err) {
        const detail = err.response?.data?.detail;
        setError(typeof detail === "string" ? detail : err.message || "Banklogin mislykkedes");
      }
    })();
  }, [navigate, searchParams]);

  return (
    <Box sx={{ py: 6, textAlign: "center" }}>
      {error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <>
          <CircularProgress size={28} />
          <Typography sx={{ mt: 2 }}>Gemmer bankforbindelse…</Typography>
        </>
      )}
    </Box>
  );
}

export default FinanceCallback;
